import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import Auth from './core/auth';
import NoAuth from './core/no-auth';
import { WithLoader } from './common/loader';
import { portalTheme } from '../styles/themes';
import { useHistoryInterceptor } from './hooks';
import { WithClientStatus } from './common/client-status';
import { WithToastNotification } from './common/toast-notification';
import { useAuthentication } from './authentication/useAuthentication';

const Root = () => {
  const { auth, loading, privileges, clientStatus, userAccount } = useAuthentication();
  useHistoryInterceptor();

  return (
    <ThemeProvider theme={portalTheme}>
      <Box width="100%" height="100%">
        <WithLoader loading={loading}>
          <WithToastNotification>
            {auth ? (
              <WithClientStatus initPrivileges={privileges} initClientStatus={clientStatus} userAccount={userAccount}>
                <Auth />
              </WithClientStatus>
            ) : (
              <NoAuth />
            )}
          </WithToastNotification>
        </WithLoader>
      </Box>
    </ThemeProvider>
  );
};

export default Root;
